<template>
<div>
      <div class="contact-banner">
        <div class="content-banner">
          <div class="container">
            <h3> Let's work together </h3>
            <p> Kan jij je vinden in onze missie en sta je voor een meer duurzame, zelfbewust en 
              inclusieve samenleving? Neem dan <span>vrijblijvend</span> contact met ons op voor een identiteitsessie. 
              Goed om te weten, wij leveren <span>maatwerk</span> maar tegen een <span>standaard prijs </span> ;) wel zo fijn toch??
            </p>
            <scissorsButton>
            <a href="tel:0403046785" class="button"><p>Bel nu!</p></a>
            </scissorsButton>
            <router-link to="/contact" class="inline-contact"> Of vul ons contactformulier in </router-link>
          </div>
        </div>
      <img class="desk-contact" src="../../assets/Folded_Paper-contact-banner.svg">
     <div class="container">
       <img class="mob-contact" src="../../assets/Folded_Paper-contact-banner-mobile.svg">
     </div>
      </div>

  <footer class="footer">

    <div class="footer-top">
      <div class="container">
        <div class="content">
          <router-link to="/"><img src="../../assets/Folded_Paper_logo_footer.png"></router-link>
          <a href="tel:0634026022">06-34026022</a>
          <a href="mailto:hello@foldedpaper.nl">hello(at)foldedpaper.nl</a>
          <br>
          <p>Molenstraat 35<br>6099 AH, Beegden<br>Nederland</p>
        </div>
      </div>
    </div>
      <div class="footer-bottom"><p><router-link class="router-link" to="/algemene-voorwaarden">Algemene voorwaarden</router-link> •<router-link class="router-link" to="/privacy-verklaring"> Privacy verklaring</router-link></p></div>
    
    <div class="font-box">
      <div id="font-calc-netflix"></div>
      <div id="font-calc-contact"></div>
      <div id="font-calc"></div>
      <div id="font-calc-5"></div>
      <div id="font-calc-3"></div>
      <div id="font-calc-kiosk"></div>
      <div id="font-calc-culture"></div>
    </div>
    </footer>
  </div>

</template>
<script>

import scissorsButton from '@/components/generalLayout/scissorsButton.vue';

export default {
  name: 'footerComponent',
    components:{
    scissorsButton
  },
}
</script>

<style lang="scss" scoped>

@import '../../scss/_base.scss';

span{
  font-weight: 800;
}
.mob-contact{
  display: none;
}

.button-box {
  float: left;
  margin-right: 16px;
  z-index: 99;

}

.button {
  margin: 0 !important;
  display: inline-block;
  text-decoration: none;
  z-index: 99;

   p{
     margin: 0;
    font-weight: 800;
   }
}
.inline-contact {
  display: inline-block;
  position: relative;
  top:8px;
  font-family: $font-stack-copy;
  text-decoration: none;
}
.contact-banner {
  position: relative;
  img {
    width: 100%;
    margin-bottom: -10px;
    max-height: 580px;
  }
}
.content-banner {
  position: absolute;
  top:50%;
  left: 50%;
  transform: translate3d(-70%, -50%, 0);
  min-width: 500px;
  max-width: 600px;
}
  .footer{
    position: relative;
    z-index: 999;
    .footer-top{
    background: $black;
    color: $white;
    clear: both;
    opacity: 0;
    @include opacityShow;
      img,a{
        margin: 0 auto;
        display: block;
        position: relative;
        pointer-events: all;
      }
      .router-link-active {
        width: 45px;
      }
      img{
        padding: layout-val-8(4) layout-val-8(0);
        max-width: layout-val-64(0.7);
        a{
          height: 100px;
        }
      }
      a,p{
        text-align: center;
        color: $white;
      }
      a{
        font-family: $font-stack-copy;
        text-decoration: underline;
        @include fluid-type(12px, 18px);
      }
      p{
        padding-bottom: layout-val-8(4);
        opacity: 1;
        margin-bottom: 0;
      }
      .container{
        &::before{
          content:'';
          background: url(../../assets/Folded_Paper_Footer_before.png);
          background-repeat: no-repeat;
          position: absolute;
          top:8px;
          left:0;
          width: 100%;
          height: 100%;
          
        }
      }
    }
    .footer-bottom{
      p{
        display: block;
        text-align: center;
        min-height:60px;
        line-height: 60px;
        margin: 0;
        @include fluid-type(12px, 14px);
      }
      a{
        text-decoration: none;
        font-weight: 300;
        color: rgba(0,0,0,0.7);
        font-family: $font-stack-copy;
        @include transition;

          &:hover{
            color: $black;
            @include transition;
          }
      }
    }
    .font-box{
      display: none;
    }
  }

@media screen and (max-width: 1050px) {
  .content-banner {
    transform: translate3d(-65%, -50%, 0);
  }
}

@media screen and (max-width: 990px) {
  img.mob-contact{
    max-height: 300px;
  }
  .content-banner {
    transform: translate3d(-65%, -50%, 0);
  }
  .mob-contact{
  display: block;
  }
  .desk-contact{
  display: none;
  }
  .content-banner {
    position: relative;
    transform: none;
    left:0;
    min-width: 1px;
  }
  .mob-contact {
    width: auto !important;
    margin-bottom: -10px;
    position: relative;
    right: -40px;
    float: right;
    max-height: 270px;
  }
  .inline-contact {
    display: none;
  }
}


</style>